export class IUploadOptions {
  // ä¸ä¼ æ¥å£å°å
  uri: string;
  // http è¯·æ±æ¹æ³
  method?: string;
  // ä¸ä¼ æä»¶å¤§å°éå¶
  maximumSize?: number;
  // èªå®ä¹è¯·æ±headers
  headers?: { [key: string]: any };
  // è®¤è¯token
  authToken?: string;
  // è®¤è¯token headeræ ç¤º
  authTokenHeader?: string;
  // ä¸ä¼ é¢å¤èªå®ä¹åæ°
  additionalParameter?: { [key: string]: any };
  // ä¸ä¼ æä»¶å­æ®µåç§°ï¼é»è®¤file
  fileFieldName?: string;
  // å¤æä»¶ä¸ä¼ ,æ¯å¦æ£æ¥æä»¶éåï¼è®¾ç½®ä¸ºtrueï¼éåæä»¶ä¸ä¼è¦çï¼å¦åä¼è¦çä¸ä¼ 
  checkSameName?: boolean;
  // æç¤ºäºæ¯å¦è¯¥ä½¿ç¨ç±»ä¼¼cookies,authorization headers(å¤´é¨ææ)æèTLSå®¢æ·ç«¯è¯ä¹¦è¿ä¸ç±»èµæ ¼è¯ä¹¦æ¥åå»ºä¸ä¸ªè·¨ç«ç¹è®¿é®æ§å¶ï¼cross-site Access-Controlï¼è¯·æ±
  withCredentials?: boolean;
}

export class IFileOptions {
  accept?: string;
  multiple?: boolean;
}

export enum UploadStatus {
  preLoad = 0,
  uploading,
  uploaded,
  failed
}
